function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8356 8H15.8505L12.4481 10.8125H14.4332L17.8356 8Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.2661 8H19.2527L15.8503 10.8125H17.8355L21.2661 8Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2526 10.8125H22.2581V8.46875C22.2581 8.43259 22.2465 8.40066 22.2395 8.36684L19.2526 10.8125Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.01758 10.8125H11.031L14.4334 8H12.4483L9.01758 10.8125Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.74194 22.5312C7.74194 22.7903 7.93216 23 8.16722 23H21.8328C22.0679 23 22.2581 22.7903 22.2581 22.5312V11.75H7.74194V22.5312ZM12.8736 14.0938C12.8736 13.9248 12.9558 13.7692 13.0892 13.6859C13.2225 13.6026 13.3861 13.6048 13.5178 13.6918L17.7705 16.5043C17.8985 16.589 17.9769 16.7414 17.9769 16.9062C17.9769 17.071 17.8984 17.2234 17.7705 17.3081L13.5178 20.1206C13.3861 20.2076 13.2224 20.2098 13.0892 20.1266C12.9558 20.0433 12.8736 19.8877 12.8736 19.7188V14.0938Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.16722 8C7.93216 8 7.74194 8.20966 7.74194 8.46875V10.6955L11.0312 8H8.16722Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7241 14.9218V18.8907L16.7252 16.9063L13.7241 14.9218Z",
  fill: "#121212"
});

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.2fcc43ac.svg";
export { ForwardRef as ReactComponent };